(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hcft-merch-product"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize = () => document.querySelectorAll('[data-hcft-colors]').forEach(root => {
  if(root.dataset.ready) return;
  root.dataset.ready='true';
  const data=JSON.parse(root.querySelector('[data-color-data]').textContent);
  const photo=root.querySelector('[data-merch-image]');
  const form=root.querySelector('form');
  const button=root.querySelector('[data-merch-buy]');
  const update=()=>{
   const color=root.querySelector('[name="hcft-color"]:checked').value;
   const selected=data[color];
   let size=root.querySelector('[name="hcft-size"]:checked')?.value;
   root.querySelectorAll('[name="hcft-size"]').forEach(input=>{
    const v=selected.variants.find(v=>v.option1===input.value);
    input.disabled=!v||!v.available;
   });
   let variant=selected.variants.find(v=>v.option1===size&&v.available);
   if(!variant){variant=selected.variants.find(v=>v.available);if(variant){root.querySelectorAll('[name="hcft-size"]').forEach(input=>input.checked=input.value===variant.option1);}}
   form.querySelector('[name="id"]').value=variant?.id||'';
   const productId=form.querySelector('[name="product-id"]');if(productId)productId.value=selected.id;
   button.disabled=!variant;
   photo.src=selected.image;
   photo.alt=selected.alt;
   photo.removeAttribute('srcset');
   root.querySelector('[data-merch-price]').textContent=new Intl.NumberFormat(document.documentElement.lang||'pl',{style:'currency',currency:root.dataset.currency||'PLN'}).format((variant?.price||selected.variants[0].price)/100);
  };
  root.addEventListener('change',event=>{if(event.target.matches('[name="hcft-color"],[name="hcft-size"]'))update();});
  let start=null;
  const area=root.querySelector('.hcft-merch-photo');
  area.addEventListener('pointerdown',event=>{start={x:event.clientX,y:event.clientY};});
  area.addEventListener('pointerup',event=>{
   if(!start)return;
   const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;
   if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5){
    const next=root.querySelector('[name="hcft-color"]:not(:checked)');
    if(next){next.checked=true;update();}
   }
  });
  area.addEventListener('pointercancel',()=>{start=null;});
  update();
 });
 initialize();
 document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hcft-nav"]) return;
  try {
    
(() => {
 let sequence = 0;
 const refresh = async () => {
  const link = document.querySelector('[data-hcft-cart-url]');
  if (!link) return;
  const request = ++sequence;
  try {
   const response = await fetch(link.dataset.hcftCartUrl, {credentials:'same-origin',cache:'no-store'});
   if (!response.ok) return;
   const cart = await response.json();
   if(request !== sequence) return;
   document.querySelectorAll('[data-hcft-cart-count]').forEach(node => {node.textContent=String(cart.item_count);});
  } catch(e) {}
 };
 window.addEventListener('pageshow', refresh);
 document.addEventListener('cart-section:restored',refresh);
 import('@shopify/events').then(({StandardEvents}) => {
  document.addEventListener(StandardEvents.cartLinesUpdate,async event => {
   try {if(event.detail?.promise)await event.detail.promise;}catch(e){}
   refresh();
  });
 }).catch(()=>{});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
